import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Silence non-error console output in production. The codebase has ~90
// debug `console.log`/`console.warn` calls; stripping them here keeps the
// browser console signal-to-noise high without touching every call site.
// Pass `?debug=1` to keep them on if you need to diagnose a prod issue.
if (process.env.NODE_ENV === "production") {
  const params = new URLSearchParams(window.location.search);
  if (params.get("debug") !== "1") {
    const noop = () => {};
    // eslint-disable-next-line no-console
    console.log = noop;
    // eslint-disable-next-line no-console
    console.debug = noop;
    // eslint-disable-next-line no-console
    console.warn = noop;
    // console.error is intentionally preserved.
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register the Web Push service worker (T8). Best-effort: if the browser has no
// SW/Push support, or registration fails, the app silently falls back to the
// existing in-app bell + foreground desktop alerts. The SW only handles push
// display + click; it does not cache/intercept app requests.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      /* no-op: push simply stays unavailable */
    });
  });
}
